<template>
  <div>
    <div class="d-flex flex-column h-100" v-if="!chatBot.loading">
      <div>
        <SystemBar />
      </div>
      <div class="d-flex flex-column h-100" v-if="chatBot.bot">
        <div>
          <v-sheet class="px-3 pb-3 d-flex align-center" color="primary">
            <div class="pr-4">
              <BotAvatar :img="chatBot.bot.data.avatar" />
            </div>
            <div class="text-white">
              <div>
                {{ chatBot.bot.data.name }}
              </div>
              <div>
                <small>
                  Conectado ahora
                </small>
              </div>
            </div>
          </v-sheet>
        </div>
        <div class="flex-fill overflow-auto pa-2">
          <div
            v-for="(message, index) in messages.list"
            :key="`message-${index}`"
            id="chat-message"
          >
            <Message
              :message="message.data"
              :signal="message.signal"
            />
          </div>
          <div
            v-if="messages.receiving"
            id="chat-message"
            class="px-3"
          >
            <v-progress-circular
              color="primary"
              indeterminate
              size="12"
              width="2"
              class="mr-2"
            ></v-progress-circular>
            <small class="text--secondary">
              <em>Está escribiendo...</em>
            </small>
          </div>
        </div>
        <div>
          <v-divider></v-divider>
          <v-slide-y-transition>
            <v-sheet
              color="white"
              elevation="4"
            >
              <TextField
                :attachments="false"
                @sendMessage="sendMessage"
              />
            </v-sheet>
          </v-slide-y-transition>
        </div>
      </div>
      <div class="text-center pa-5 ma-5" v-else>
        Chatbot no disponible para este departamento
      </div>
    </div>
    <div v-else>
      <div
        class="text-center pa-5 ma-5"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          width="2"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainAiChatbotService from '@/services/MainAiChatbotService'

@Component({
  components: {
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    TextField: () => import(/* webpackPrefetch: true */ '@/views/session/components/chat/resources/TextField.vue'),
    Message: () => import(/* webpackPrefetch: true */ '@/views/chat/components/Message.vue'),
    BotAvatar: () => import(/* webpackPrefetch: true */ '@/views/chat/bot/resources/BotAvatar.vue'),
    Empty: () => import(/* webpackPrefetch: true */ '@/views/session/resources/Empty.vue')
  },
  computed: {
    customer () {
      return this.$store.state.storage.room.customer
    },
    room () {
      return this.$store.state.storage ? this.$store.state.storage.room : null
    },
    organization () {
      return this.$store.state.widget.data ? this.$store.state.widget.data.organization : null
    },
    enableChatBot () {
      return this.$organization.enableChatBot()
    }
  }
})
export default class ChatBot extends Vue {
  data () {
    return {
      messages: {
        sending: false,
        receiving: false,
        list: []
      },
      chatBot: {
        loading: false,
        bot: null
      }
    }
  }

  mounted () {
    this.makeWelcome()
  }

  scrollIntoLastMessage () {
    setTimeout(() => {
      const lastMessageElement = document.querySelector('#chat-message:last-child')
      if (lastMessageElement) {
        lastMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'end' })
      }
    }, 800)
  }

  createMessage ({ signal, data }) {
    this.messages.list.push({
      data,
      signal
    })

    this.scrollIntoLastMessage()
  }

  async createInteraction (input) {
    this.messages.sending = true
    this.messages.receiving = true

    this.scrollIntoLastMessage()

    const data = {
      route: '/chat',
      params: {
        input,
        chatbot_id: this.chatBot ? this.chatBot.id : null,
        category_id: null,
        organization_id: this.organization ? this.organization.id : null,
        customer: this.customer,
        data: {
          session_id: this.room ? this.room.session_id : null
        }
      }
    }

    return MainAiChatbotService.post(data)
      .then((response) => {
        const res = response.data
        if (res.statusCode === 0) {
          this.createMessage({ signal: 'their', data: res.data })
        }
      })
      .catch((error) => {
        console.log('MainAiChatbotService:sendMessage ERROR', error)
      })
      .then(() => {
        this.messages.sending = false
        this.messages.receiving = false
      })
  }

  async makeWelcome () {
    if (this.enableChatBot()) {
      return false
    }

    this.chatBot.loading = true

    const data = {
      route: '/config',
      params: {
        organization_id: this.organization ? this.organization.id : null,
        category_id: 1
      }
    }

    return MainAiChatbotService.get(data)
      .then((response) => {
        const res = response.data
        if (res.statusCode === 0) {
          this.chatBot.bot = res.data
          if (this.chatBot.bot) {
            const customerName = this.customer?.name
            const input = `Hola${customerName ? ` mi nombre es ${customerName}` : ''}`
            return this.createInteraction(input)
          }
        }
      })
      .catch((error) => {
        console.log('makeWelcome', error);
      })
      .then(() => {
        this.chatBot.loading = false
      })
  }

  async sendMessage (message) {
    this.createMessage({ signal: 'mine', data: message })
    return this.createInteraction(message)
  }
}
</script>
